export default {
  // ORDER EVENTS
  // Creating
  ORDER_CREATED: "success",
  ORDER_ITEM_ADDED: "success",
  INQUIRY_CREATED: "success",

  // Removing
  ORDER_ITEM_REMOVED: "secondary",
  ORDER_EXPIRED: "secondary",
  ORDER_ANONYMIZED: "secondary",
  ORDER_ARCHIVED: "secondary",

  // Updating
  ORDER_UPDATED: "amber",
  ORDER_PASSENGER_UPDATED: "amber",
  ORDER_VALIDATED: "amber",
  ORDER_TENANT_CHANGED: "amber",
  ORDER_PURCHASE: "amber",
  ORDER_PRINTED: "amber",
  ORDER_UNARCHIVED: "amber",
  ORDER_EXPIRATION_EXTENDED: "amber",

  // Locking & Unlocking
  ORDER_LOCKED: "#34495e",
  ORDER_LOCKED_FOR_PRINTING: "#34495e",
  ORDER_UNLOCKED_FOR_PRINTING: "#34495e",
  ORDER_ITEM_LOCKED_FOR_REMOVAL: "#34495e",
  ORDER_ITEM_UNLOCKED_FOR_REMOVAL: "#34495e",

  // Sending E-mails
  ORDER_RAILPASS_ACTIVATION_EMAIL_SENT: "accent",
  ORDER_PRINTED_EMAIL_SENT: "accent",
  ORDER_REFUNDED_EMAIL_SENT: "accent",
  ORDER_EXPIRED_MAIL_SENT: "accent",
  ORDER_CONFIRMATION_SENT: "accent",
  ORDER_TICKETS_SENT: "accent",
  ORDER_RECEIPTS_SENT: "accent",
  LOGIN_2FA_CODE_SENT: "accent",

  // Cancelling
  ORDER_CANCELLED: "danger",
  ORDER_SHIPMENT_CANCELLED: "danger",

  // Refunding
  ORDER_REFUNDED: "warning",
  ORDER_REFUNDED_SPECIAL: "warning",
  ORDER_REFUND_CALLBACK_RECEIVED: "warning",

  // TRAID comment events
  ORDER_BOOKING_COMMENT_CREATED: "#010845",
  ORDER_BOOKING_COMMENT_UPDATED: "#010845",
  ORDER_BOOKING_COMMENT_DELETED: "#010845",

  // Other
  COMMENT: "grey lighten-1",
  ORDER_RECEIPTS_PROVIDED: "grey lighten-1",
  LOGIN_SUCCESS: "grey lighten-1",

  // CLAIM EVENTS
  // Waiting For
  waiting_for_operator: "#FFB300",
  waiting_for_customer_details: "#FFB300",
  waiting_for_tickets: "#FFB300",
  waiting_for_document: "#FFB300",
  waiting_for_silverrail: "#FFB300",

  // Events
  document_returned: "accent",
  tickets_cancelled: "accent",
  documents_arrived: "accent",

  // Refunding
  refund_linkonline_fe: "warning",
  refund_linkonline_at: "warning",
  refund_linkonline_ao: "warning",
  refund_linkonline_sf: "warning",
  refund_klarna: "warning",
  refund_fortnox: "warning",
  refund_giftcard: "warning",
  refund_taxi: "warning",
  checked_by_tp: "warning",
  authorized_by_tenant: "warning",

  // Others
  comment: "secondary",
  INQUIRY_CUSTOMER_UPDATED: "secondary",

  // ACCOUNT EVENTS
  // Creating
  ACCOUNT_CREATED: "success",
  ACCOUNT_PASSENGER_CREATED: "success",
  ACCOUNT_ADDRESS_CREATED: "success",
  ACCOUNT_UNDELETED: "success",
  ACCOUNT_CUSTOMER_ADDED: "success",
  ACCOUNT_VERIFIED: "success",

  // Removing
  ACCOUNT_ANONYMIZED: "secondary",
  ACCOUNT_PASSENGER_DELETED: "secondary",
  ACCOUNT_ADDRESS_DELETED: "secondary",
  ACCOUNT_CUSTOMER_REMOVED: "secondary",

  // Updating
  ACCOUNT_UPDATED: "amber",
  ACCOUNT_PASSENGER_UPDATED: "amber",
  ACCOUNT_ADDRESS_UPDATED: "amber",
  ACCOUNT_PASSWORD_CHANGED: "amber",

  // Login
  ACCOUNT_LOGIN_SUCCESS: "#34495e",

  // Sending E-mails
  ACCOUNT_VERIFICATION_MAIL_SENT: "accent",
  ACCOUNT_RESET_PASSWORD_MAIL_SENT: "accent",
  ACCOUNT_INACTIVITY_MAIL_SENT: "accent",
  ACCOUNT_DELETED_MAIL_SENT: "accent",
  ACCOUNT_CREATED_MAIL_SENT: "accent",
  ACCOUNT_COMPANY_CONNECTED_MAIL_SENT: "accent",
  ACCOUNT_COMPANY_DISCONNECTED_MAIL_SENT: "accent",
  ACCOUNT_COMPANY_MANAGER_ADDED_MAIL_SENT: "accent",
  ACCOUNT_COMPANY_MANAGER_REMOVED_MAIL_SENT: "accent",

  // Deleting
  ACCOUNT_DELETED: "danger",

  // Warning
  ACCOUNT_PERSONAL_DATA_REQUESTED: "warning",
  ACCOUNT_LOCKED: "warning",
};
